import avo from '../../vendors/avo';
import AvoDestination from '../../vendors/avo-destination';

(() => {
    const sendEventUsingAvo = (methodName, params, environment, source) => {
        console.log(`sendEventUsingAvo with method: ${methodName}`, params, environment, source);
        if(source == "web-ui") {
            initalizeAndCallAvo(methodName, params, environment);
            return;
        }
        environment = AvoConfig.env == 'production' ? 'prod' : 'dev';
        initalizeAndCallAvo(methodName, params, environment);
    }

    const flushBufferedEvents = () => {
        console.log('Avo: Flushing buffered events');
        const avoEvents = window.avoBufferedEvents;
        if (avoEvents && avoEvents.length > 0) {
            for (const eventArgs of avoEvents) {
                sendEventUsingAvo(eventArgs['methodName'], eventArgs['params'], eventArgs['environment'], eventArgs['source']);
            }
            window.sendEventUsingAvo = [];
        }
    }

    const initalizeAndCallAvo = (methodName, params, environment) => {
        console.log(`initalizeAndCallAvo with method: ${methodName}`, params, environment);
        var payload = params;
        try {
            payload = params && JSON.parse(params);
        } catch(e) {}
        if(methodName) {
            try {
                avo.initAvo({env: environment}, {}, {}, AvoDestination);
                avo.setSystemProperties({screenHeight: window.innerHeight});
                avo[methodName](payload);
            }
            catch(error) {
                console.error(error);
            }
        }
    }

    window.sendEventViaAvoWrapperCore = (methodName, params, environment, source) => {
        console.log(`sendEventViaAvoWrapperCore: ${methodName}`, params, environment, source);
        flushBufferedEvents();
        sendEventUsingAvo(methodName, params, environment, source);
    }
})();
